// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"92d98ea6","879":"8a13cf4c"}[chunkId] + ".chunk.js";
};